import { makeAuthenticatedRequest } from "./authApi";
import { getApiUrl } from "../utils/envConfig";

// Group-invite-link management (FastAPI /invite-links), the staff view over the
// Firestore `invite_links` collection. Hand-written and kept in lockstep with
// the API surface per .claude/rules/admin-api-client-parity.md.

// List invite links. Omit id_client → a Dashmote admin sees every workspace's
// links, any other staffer sees only the workspaces they administer; pass one →
// that workspace's links. The response carries only an 8-char token prefix,
// never the bearer token.
export const listInviteLinks = async (idClient) => {
  const query = idClient
    ? `?id_client=${encodeURIComponent(idClient)}`
    : "";
  return makeAuthenticatedRequest(`${getApiUrl()}/invite-links${query}`);
};

// Revoke a link (one-way): sets is_active:false so the public fetch returns
// `revoked` and registration returns 410. A link is addressed by its workspace
// plus 8-char token prefix, since the full token is never returned to the
// client; the backend authorizes against that workspace.
export const revokeInviteLink = async (idClient, tokenPrefix) =>
  makeAuthenticatedRequest(`${getApiUrl()}/invite-links/revoke`, {
    method: "POST",
    body: JSON.stringify({ id_client: idClient, token_prefix: tokenPrefix }),
  });
